import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantAgendaItemsRoot = () => {
  useProtected();

  return <Outlet />;
};

export { AgendaItemPage } from "./AgendaItem";
export { AgendaItemsPage } from "./AgendaItems";
